import { Button, Flex, FlexBox, Heading, Icon, Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow, Tabs } from "@braze/beacon-core"
import { RoundedCard } from "../../shared/RoundedCard"
import { useState } from "react";
import { MarketoProgramObject } from "../../types/APITypes";
import styled from "styled-components";
import { RequiredSelect } from "../../shared/forms/RequiredSelect";
import { RequiredText } from "../../shared/forms/RequiredText";
import { formatOption } from "../../util/optionsFormatter";
import { MARKETO_DATE } from "../../constants/SelectConstants";
import { useGlobalAppContext } from "../../contexts/GlobalAppContext";
import { useCreateNewProgram } from "../../hooks/useCreateNewProgram";
import { useDeleteExistingProgram } from "../../hooks/useDeleteExistingProgram";




export const Programs = () => {

    const [program, setProgram] = useState({} as MarketoProgramObject);

    const { programs, setRefresh } = useGlobalAppContext();
    const [createProgram, createProgramResponse] = useCreateNewProgram()
    const [deleteProgram, deleteProgramResponse] = useDeleteExistingProgram()

    const handleFieldChange = (key : keyof MarketoProgramObject) => {

        return (value : string | number) => {
            
            let newVal;

            if (typeof value === "object" && value != null) {
                if (key === "has_date") {
                    newVal = {[key] : value["value"] === "Yes" ? true : false};
                }
                else { newVal = {[key] : value["value"]}; }
            } else {newVal = {[key] : value};}

            setProgram({...program, ...newVal})
        }
        
    }

    return (
        <FlexBox direction="column">
        <RoundedCard style={{margin:"0px", marginTop: "3rem"}}>
            <Flex direction="column">
                
                <GroupBox>
                    <RequiredText name={"Marketo Program ID"} handleChange={handleFieldChange("program_id")}/>
                    <RequiredText name={"SFDC Campaign Type Name"} handleChange={handleFieldChange("sfdc_type")}/>
                    <RequiredText name={"Campaign Type Abbreviation"} handleChange={handleFieldChange("abbr")}/>
                </GroupBox>

                <GroupBox>
                    <RequiredSelect name={"Campaign Name Inclues Date"} options={formatOption(MARKETO_DATE, false, false)} handleChange={handleFieldChange("has_date")}/>
                    <RequiredText name={"Campaign Name Prefix"} handleChange={handleFieldChange("prefix")} info="May leave this blank"/>
                </GroupBox>
                <GroupBox direction="column">
                    <Button style={{marginTop: "1rem"}}
                        onClick={() => {
                            createProgram(program)
                            .then(r => setRefresh(true));
                        }}>
                        Add Program
                    </Button>
                </GroupBox>
            </Flex>
        </RoundedCard>

        <RoundedCard style={{margin:"0px", marginTop: "3rem"}}>
            <Heading level={2}>Active Global Marketo Programs</Heading>
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHeaderCell>Program ID</TableHeaderCell>
                        <TableHeaderCell>SFDC Type</TableHeaderCell>
                        <TableHeaderCell>Abbreviation</TableHeaderCell>
                        <TableHeaderCell>Region</TableHeaderCell>
                        <TableHeaderCell>Has Date</TableHeaderCell>
                        <TableHeaderCell>Prefix</TableHeaderCell>
                        <TableHeaderCell>Folder</TableHeaderCell>
                        <TableHeaderCell>Delete</TableHeaderCell>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {
                        programs?.filter((p : MarketoProgramObject) => p.region === "Global").map((p) => {
                            return (
                                <TableRow>
                                    <TableCell>{p.program_id}</TableCell>
                                    <TableCell>{p.sfdc_type}</TableCell>
                                    <TableCell>{p.abbr}</TableCell>
                                    <TableCell>{p.region}</TableCell>
                                    <TableCell>{p.has_date ? "Yes" : "No"}</TableCell>
                                    <TableCell>{p.prefix}</TableCell>
                                    <TableCell>{p.folder}</TableCell>
                                    <TableCell style={{borderBottom: "0px"}}>
                                        <StyledIcon name={"x"} onClick={() => 
                                            deleteProgram(p)
                                            .then(r => setRefresh(true))}/>
                                    </TableCell>
                                    
                                </TableRow>
                            )
                        })
                    }
                </TableBody>
            </Table>
        </RoundedCard>

        </FlexBox>
    )
};

const GroupBox = styled(FlexBox)`

    justify-content: space-between;
    margin-bottom: 1rem;
    > * {
        &:not(:last-of-type) {
        margin-right: 20px;
        }
    }
    
`

const StyledIcon = styled(Icon)`
    width: 100%;    
    .svg-inline--fa {
        border-bottom: 0px !important;
    }
    cursor: pointer;
    border-bottom: 0px !important;
`

